//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from "vue";
import { mapState, mapGetters, mapMutations } from "vuex";
import { extend } from "quasar";
import AQDefaultState from "@/components/Generics/AQDefaultState/AQDefaultState.vue";
import { $http } from "@/assets/js/appFunc";
import ComponentsUtils from "./mixins/components-utils";

export default {
    name: "QfComponentsPage",
    components: {
        AQDefaultState
    },
    mixins: [ComponentsUtils],
    provide() {
        const reactive = {};

        Object.defineProperty(reactive, "canEdit", { enumerable: true, get: () => this.__isEditable() });
        Object.defineProperty(reactive, "isDesign", { enumerable: true, get: () => this.designer });
        Object.defineProperty(reactive, "isLive", { enumerable: true, get: () => this.live });
        Object.defineProperty(reactive, "activeComponent", { enumerable: true, get: () => this.activeComponent });
        Object.defineProperty(reactive, "isSmallScreen", { enumerable: true, get: () => this.isSmallScreen });
        Object.defineProperty(reactive, "language", { enumerable: true, get: () => this.userData.language });

        return {
            eventBus: this.eventBus,
            utils: {
                getMappingType: this.__getMappingType,
                getFragmentName: this.__getFragmentName,
                typeValidation: this.__typeValidation,
                typeValidationAll: this.__typeValidationAll,
                componentValidations: this.__componentValidations,
                isRegexValid: this.__isRegexValid,
                getColorValue: this.__getColorValue,
                getColorString: this.__getColorString,
                removeEntry: this.__removeEntry,
                uploadFile: this.__upload,
                downloadFile: this.__download,
                generateDocument: this.__generateDocument,
                exportArrayBuffer: this.__exportArrayBuffer,
                exportXLS: this.__exportXLS,
                downloadDocument: this.__downloadDocument,
                copyToClipboard: this.__copyToClipboard,
                getDataObject: this.__getDataObject,
                ajaxCall: this.__ajaxCall,
                integrationCall: this.__callAPI,
                startProcessCall: this.__startProcess,
                metamaskCall: this.__metamaskCall,
                signSCCall: this.__signSCCall,
                getResponse: this.__getResponse,
                reponseFormatter: this.__bcResponseFormatter,
                parseField: this.__bcResponseFieldParse,
                formatDateObject: this.__formatDateObject,
                saveInterfaceData: this.customSave,
                notify: this.__notifications,
                executeCustomEvent: this.__executeCustomEvent,
                executeCustomEventNew: this.__executeCustomEventNew,
                updateRichStore: this.__updateRichStore,
                getFromRichStore: this.__getRichContent,
                removeRichStoreEntry: this.__removeRichStoreEntry,
                checkRichText: this.__checkRichText,
                getIdxFromList: this.__getIdxFromList,
                extend
            },
            messages: {
                mandatory: this.$t("userInterface.mandatoryField")
            },
            reactive
        };
    },
    data() {
        return {
            urlHelper: "",
            eventBus: new Vue(),
            model: null,
            richTextSaveFunctions: {}
        };
    },
    computed: {
        ...mapState("userProfile", ["userData"]),
        ...mapState("components", [
            "activeComponent", "richTextCache", "live", "designer", "isSmallScreen", "fragments", "appInterfaces",
            "activeInterface", "activityId"
        ]),
        ...mapGetters("components", ["body", "getRichTextCacheByKey"]),
        isEmptyBody() {
            return !(this.body && this.body.length);
        },
        getNoInterfacesTitle() {
            return this.appInterfaces.length ? this.$t("userInterface.noDisplayInterfaces") : this.$t("userInterface.noInterfaces");
        },
        customInterface() {
            const execData = JSON.parse(localStorage.getItem("executionData"));
            return execData ? !!execData.perspectiveId : false;
        },
        getNoInterfacesDesc() {
            return this.appInterfaces.length ? " " : this.$t("userInterface.noInterfacesDesc");
        }
    },
    created() {
        this.eventBus.$on("custom:trigger", payload => {
            if ((this.designer && this.live) || !this.designer) {
                this.$emit("customEvent", payload);
            }
        });
        this.eventBus.$on("saveRichTextFunction", ({ fn, uuid }) => {
            this.richTextSaveFunctions[uuid] = fn;
        });
        this.eventBus.$on("cancelSaveRichText", ({ uuid }) => {
            delete this.richTextSaveFunctions[uuid];
        });
    },
    methods: {
        ...mapMutations("components", ["setRichTextCache", "removeRichStoreEntry"]),
        __updateRichStore(key, content, setPath) {
            this.setRichTextCache({ key, content, setPath });
        },
        __getRichContent(key) {
            const { content = null } = this.getRichTextCacheByKey(key) || {};
            return content;
        },
        __removeRichStoreEntry(key) {
            this.removeRichStoreEntry(key);
        },
        __checkRichText(data) {
            console.log("segment data => ", data);
        },
        __getIdxFromList(path, properties) {
            let index;

            if (path && properties.parent) {
                const { parent } = properties;
                const { __component: parentType } = this.properties[parent];

                if (parentType === "ctrl-segment-list") {
                    const [first, second] = path.split(",");
                    if (first === parent && second) {
                        index = parseInt(second, 10);
                    }
                }
            }

            return index;
        },
        __getMappingType(mapValue) {
            const data = { type: null, key: null };

            if (mapValue && mapValue.startsWith("m_")) {
                const pathList = mapValue.substring(2).split(".");

                if (pathList.length > 1) {
                    let cursor = this.parsed.modelClasses[pathList.splice(0, 1)[0]];

                    pathList.forEach(node => {
                        cursor = cursor && cursor.fields ? cursor.fields[node] : null;
                    });
                    if (cursor) {
                        data.type = cursor.type;
                        data.key = cursor.key;
                    }
                }
            }

            return data;
        },
        __getFragmentName(uid) {
            const msgNotFoundFr = this.$t("userInterface.notFoundFr", { id: uid });
            const { name = msgNotFoundFr } = this.fragments[uid] || {};
            return name;
        },
        remoteCall(type, config) {
            return new Promise((resolve, reject) => {
                this.$emit("remoteCall", { type, config, resolve, reject });
            });
        },
        customSave() {
            return new Promise(resolve => {
                this.$confirm("This action will save the interface data?", "Confirm", "Continue")
                    .then(() => {
                        new Promise(saveResolve => this.$emit("save", saveResolve)).then(data => {
                            resolve(data);
                        });
                    })
                    .catch(() => resolve(false));
            });
        },
        saveRichTexts() {
            // return Promise.all(Object.values(this.richTextSaveFunctions).map(fn => fn()));
            return Promise.all(Object.entries(this.richTextCache).map(([key, value]) => {
                const payload = {
                    id: key,
                    processInstanceId: this.processInstanceId,
                    variablePath: value.setPath,
                    value: value.content
                };

                const req = {
                    type: "POST",
                    url: "/engine/api/data/save/richtext",
                    data: payload
                };

                return $http(req, true).then(() => {});
            }));
        },
        pageClick(event) {
            const source = event.target;
            let bubble = true;

            if (source) {
                const backClick = source.classList.contains("container-out") || source.classList.contains("components-page");

                if (backClick) {
                    bubble = false;
                    this.$emit("action", { type: "componentClick", data: { guid: null } });
                }
            }

            return bubble;
        },
        checkMandatory() {
            return new Promise(resolve => {
                const checkFalse = element => element === false;

                this.mandatory = [];
                this.eventBus.$emit("mandatoryCheck", this.mandatory);

                this.$nextTick(() => {
                    resolve(!this.mandatory.some(checkFalse));
                });
            });
        },
        setLive(state) {
            this.live = state;
        },
        setActive(idComponent) {
            this.activeComponent = idComponent;
        }
    }
};
